// extracted by mini-css-extract-plugin
export var label = "PageSpinner-module--label--304e8";
export var pageBreathe = "PageSpinner-module--pageBreathe--32c47";
export var pageSpin = "PageSpinner-module--pageSpin--bb5c2";
export var ring = "PageSpinner-module--ring--15511";
export var wrap = "PageSpinner-module--wrap--3832f";